import { KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { mapWysiwygContent } from './Wysiwyg';

export function mapFormattedTextWithTitle(
  input: FormattedTextWithTitleFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'FormattedText'> {
  return mapWysiwygContent({
    __typename: 'ParagraphWysiwygContent',
    textHtml: input.title
      ? `<h3>${input.title}</h3>${input.textHtml}`
      : input.textHtml || '',
  });
}
